var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#7dd3fc",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 5,
    rx: 8,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.fedf90552631282f646abf4c4da5c013.svg";
export { ForwardRef as ReactComponent };